import { NgModule } from '@angular/core';
import { FlooriRadioGroupComponent } from './floori-radio-group/floori-radio-group.component';
import { FlooriRadioComponent } from './floori-radio/floori-radio.component';

const EXPORTED = [FlooriRadioComponent, FlooriRadioGroupComponent];

@NgModule({
    imports: [...EXPORTED],
    exports: [...EXPORTED],
})
export class FlooriRadioModule {}
